import { jobStatusConfig } from '@/pages/ats-job-creation/utils/constants';
import { KText } from '@/ui-library/components';
import { Box, Center, Flex, Icon } from '@chakra-ui/react';
import { Briefcase01 } from '@kula-ai/icons/dual-tone/Briefcase01';
import { LayersThree02 } from '@kula-ai/icons/dual-tone/LayersThree02';
import { MarkerPin01 } from '@kula-ai/icons/dual-tone/MarkerPin01';
import { IconText } from '../IconText';
import { JobItem as JobItemType } from '../types';
import { SearchItemWrapper } from './SearchItemWrapper';
import { Link } from 'react-router-dom';
import { useSearchManager } from '../search-manager';
import { HighlightedTooltipText } from '../text';

interface JobItemProps {
  item: JobItemType;
}

export const JobItem = ({ item }: JobItemProps) => {
  const { name, state, department = '', offices = [], id } = item;
  const { color = 'pastel-2-light', label = 'Open' } =
    jobStatusConfig?.[state] || {};
  const { onSearchClose, searchTerm } = useSearchManager();

  return (
    <Link
      to={`/jobs/${id}`}
      style={{ textDecoration: 'none' }}
      onClick={() => {
        onSearchClose();
      }}
    >
      <SearchItemWrapper>
        <Flex alignItems="center" gap="12px">
          <Center
            width="36px"
            height="36px"
            borderRadius="xs"
            bg="pastel-7-light"
          >
            <Icon
              as={LayersThree02}
              color="pastel-7-dark"
              width="1rem"
              height="1rem"
            />
          </Center>
          <Flex flexDirection="column" gap="3px" overflow="hidden">
            <Flex gap="6px" overflow="hidden">
              <HighlightedTooltipText
                variant="heading_3"
                color="primary-900"
                text={name}
                maxW="100%"
                highlight={searchTerm}
              />
              <KText
                variant="paragraph"
                color="secondary-700"
                p="1px 8px"
                borderRadius="xs"
                border="1px solid"
                borderColor="secondary-100"
                textTransform="capitalize"
                display="flex"
                alignItems="center"
                gap="4px"
                lineHeight="20px"
                whiteSpace="nowrap"
              >
                <Box bg={color} borderRadius="full" w="8px" h="8px" />
                {label}
              </KText>
            </Flex>
            <Flex gap="12px">
              {department && <IconText icon={Briefcase01} text={department} />}
              {offices.length > 0 && (
                <IconText
                  icon={MarkerPin01}
                  text={offices.join(', ')}
                  wrapperProps={{ gap: '4px' }}
                />
              )}
            </Flex>
          </Flex>
        </Flex>
      </SearchItemWrapper>
    </Link>
  );
};
